import { isNotDefined } from '@sgme/fp';
import { correlationGraphApi } from 'apiConnector/correlation-graph';
import { ofType } from 'redux-observable';
import { catchError, EMPTY, mergeMap, of, withLatestFrom } from 'rxjs';
import { showNotificationThunk } from 'state/notifications/notification.thunk';
import {
  saveCorrelationsInputsFailed,
  saveCorrelationsInputsSucceeded,
} from 'state/quotes/correlations/correlations.action';
import { getCorrelationsByTabId } from 'state/quotes/correlations/correlations.selectors';
import { getFormEnrichedTradeDate, getFormProductSubType, getPricerRfqIdByWorkspaceTab } from 'state/selectors';
import { EpicWithThunk } from 'state/state.common';
import { extractHttpErrorMessage, FunctionalMessage, HttpError } from 'utils/http/httpClient.model';

export function correlationGraphEpic(): EpicWithThunk {
  return (actions$, state$, { httpClient }) =>
    actions$.pipe(
      ofType('SAVE_CORRELATION_INPUTS'),
      withLatestFrom(state$),
      mergeMap(([{ tabId, workspace }, state]) => {
        const correlations = getCorrelationsByTabId(state, tabId);
        const tradeDate = getFormEnrichedTradeDate(state, tabId);
        const pricerRfqId = getPricerRfqIdByWorkspaceTab(state, workspace, tabId);
        const productSubtype = getFormProductSubType(state, tabId);
        if (
          isNotDefined(correlations) ||
          isNotDefined(tradeDate) ||
          isNotDefined(pricerRfqId) ||
          isNotDefined(productSubtype)
        ) {
          return EMPTY;
        }
        return correlationGraphApi(httpClient)
          .persist({
            productSubtype,
            pricerRfqId,
            tradeDate,
            askCorrelation: correlations.askCorrelation ?? undefined,
            askPrice: correlations.askPrice ?? undefined,
            bidCorrelation: correlations.bidCorrelation ?? undefined,
            bidPrice: correlations.bidPrice ?? undefined,
          })
          .pipe(
            mergeMap(() =>
              of(
                showNotificationThunk({ level: 'success', title: { id: 'correlation.save.successMessage' } }),
                saveCorrelationsInputsSucceeded(tabId, workspace),
              ),
            ),
            catchError((err: HttpError<FunctionalMessage>) => {
              return of(
                showNotificationThunk({
                  level: 'danger',
                  title: extractHttpErrorMessage(err) ?? { id: 'correlation.save.defaultErrorMessage' },
                }),
                saveCorrelationsInputsFailed(tabId, workspace),
              );
            }),
          );
      }),
    );
}
